module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "air-quality-and-covid-19--discovery-cover.223fafff.jpg";